export default __webpack_public_path__ + "static/media/ic_trash.61dbf832.svg";